if(!customElements.get('swatch-image')) {
    class SwatchImage extends HTMLElement {
        constructor() {
            super();
            this.handlers = {
                click: this._HandleClick.bind(this)
            }
        }
        connectedCallback() {
            this.addEventListener('click', this.handlers.click);
        }
        disconnectedCallback() {
            this.removeEventListener('click', this.handlers.click);
            document.removeEventListener('GoToActiveImage', (e) => this.handlers.goToActiveImage(e));
        }
        _HandleClick(event) {
            if(event.target.closest('.image')) {
                if(event.target.closest('.image').classList.contains('active')) {
                    return false;
                }
                const optionValues = event.target.closest('.option-values') ? event.target.closest('.option-values').querySelectorAll('.image') : null;
                const optionName = this.querySelector('.option-name strong');
                optionName && (optionName.innerText = event.target.closest('.image') && event.target.closest('.image').dataset.variantTitle);
                if(optionValues.length > 0) {
                    optionValues.forEach(option => {
                        option.classList.remove('active');
                    })
                }
                event.target.closest('.image').classList.add('active');
                document.dispatchEvent(
                    new CustomEvent('GotToSlide', {
                      detail: event.target.closest('.image').dataset.variantImageSrc
                    })
                );
                const productForm = event.target.closest('product-form');
                if(productForm) {
                    const nameId = productForm.querySelector('select[name="id"]');
                    if(nameId) {
                        for(const [i, option] of Array.from(nameId.options).entries()) {
                             if(parseInt(event.target.closest('.image').dataset.variantId) === parseInt(option.value)) {
                                nameId.selectedIndex = i;
                            }
                        }
                    const url = new URL(window.location);
                    const currentTitle = document.title;
                    const currentState = history.state;
                    url.searchParams.set('variant', nameId.options[nameId.selectedIndex].value);
                    window.history.replaceState(currentState, currentTitle, url);
                    }
                    const discountedPriceEl = productForm.querySelector('[data-product-current-price="true"]');
                    const discountedCompareAtPriceEl = productForm.querySelector('[data-compare-at-price="true"]');
                    const savingDetailsEl = productForm.querySelector('.product__price-savings');
                    const addToCartEl = productForm.querySelector('[name="add"]');
                    const variantIsAvailable = event.target.closest('.image') ? event.target.closest('.image').dataset.variantAvailability : null;
                    if(variantIsAvailable === 'true') {
                        addToCartEl && (addToCartEl.disabled = false);
                        const discountPercentageValue = parseInt(this.dataset.discountPercentageValue);
                        const currencyCode = this.dataset.currencyCode;
                        if(isNaN(discountPercentageValue)) {
                            const variantPrice = parseInt(event.target.closest('.image').dataset.variantPrice);
                            const formattedVariantPrice = new Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: currencyCode,
                                maximumFractionDigits: 0
                            }).format(variantPrice);
                            discountedPriceEl && (discountedPriceEl.innerText =  formattedVariantPrice);
                        }
                        if(discountPercentageValue > 0 && currencyCode) {
                            const variantPrice = parseInt(event.target.closest('.image').dataset.variantPrice);
                            const formattedVariantPrice = new Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: currencyCode,
                                maximumFractionDigits: 0
                            }).format(variantPrice);
                            discountedPriceEl && (discountedPriceEl.innerText =  formattedVariantPrice);
                            const discountPriceSum = variantPrice * (discountPercentageValue * .01);
                            const finalDiscountedPrice = variantPrice - discountPriceSum;
                            const formattedVariantDiscountedPrice = new Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: currencyCode,
                                maximumFractionDigits: 0
                            }).format(finalDiscountedPrice);
                            discountedCompareAtPriceEl && (discountedCompareAtPriceEl.innerText = formattedVariantDiscountedPrice);
                            const formattedSavedAmount = new Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: currencyCode,
                                maximumFractionDigits: 0
                            }).format(discountPriceSum);
                            savingDetailsEl && (savingDetailsEl.innerText = `SAVE ${formattedSavedAmount} (${discountPercentageValue}%)`)
                        }
                    } else {
                        addToCartEl && (addToCartEl.disabled = true);
                    }                    
                }               
            }
        }
    }
    customElements.define('swatch-image', SwatchImage);
}